import { render, staticRenderFns } from "./VentaEditarModalPerseo.vue?vue&type=template&id=edb38fa8&scoped=true"
import script from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
export * from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./VentaEditarModalPerseo.vue?vue&type=style&index=0&id=edb38fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb38fa8",
  null
  
)

export default component.exports